/**
 * Drains `ATTENTION_PROJECTIONS` once, at app start (D158).
 *
 * Deliberately dumb: it owns no counts and decides nothing. Its whole job is
 * that registration happens somewhere that is not a component, so a rail badge
 * outlives the screen it points at.
 *
 * There is no `unregister`. A rule is a property of the tenant's
 * configuration, not of what is currently on screen — and the resolver already
 * removes the badge when the capability behind it goes off (D3), which is the
 * only reason a rule should ever stop counting.
 */

import {
  EnvironmentInjector,
  inject,
  Injectable,
  runInInjectionContext,
} from '@angular/core';

import { ATTENTION_PROJECTIONS } from './attention-projections';
import { AttentionService } from './attention.service';

@Injectable({ providedIn: 'root' })
export class AttentionRegistrar {
  private readonly attention = inject(AttentionService);
  private readonly injector = inject(EnvironmentInjector);
  private readonly factories = inject(ATTENTION_PROJECTIONS, {
    optional: true,
  });

  private done = false;

  /** Idempotent: a second call is a no-op, not a duplicate registration. */
  registerAll(): void {
    if (this.done) {
      return;
    }
    this.done = true;
    for (const make of this.factories ?? []) {
      /* Explicitly, rather than relying on being called from inside an
         initializer's stack: a projection factory injects the store it reads,
         and that must not depend on who called us. */
      for (const p of runInInjectionContext(this.injector, make)) {
        this.attention.register(p.rule, p.count, p.tone);
      }
    }
  }
}
